import { render, staticRenderFns } from "./TreeselectControl.vue?vue&type=template&id=6206fee4&scoped=true&"
import script from "./TreeselectControl.vue?vue&type=script&lang=js&"
export * from "./TreeselectControl.vue?vue&type=script&lang=js&"
import style0 from "./TreeselectControl.vue?vue&type=style&index=0&id=6206fee4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206fee4",
  null
  
)

export default component.exports